// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailC":"C_wave2DetailC__EB79g"};